import {Deserializable} from "./deserializable.model";

export class JobTypeDocument {

job_type_document_id: number;
job_type_document_name: string;
job_type_document_description: string;
is_active: string;
job_type_location_id: number;
job_type_id: number;
job_type_court_id: number;

job_type_document_type_description: string;
job_type_document_type_name: string;

job_service_timeframe_id: number;
job_service_rule_id: number;


  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): JobTypeDocument {
    Object.assign(this, input);

    return this;
  }


}
